import { observer } from 'mobx-react-lite'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useStore from 'reusable/mobx-store-utils'
import FileUploadWithProgress from 'reusable/mui/file-uploads/FileUploadWithProgress'
import CreateClientCSVImportStore from './CreateClientCSVImportStore'
import { useGapDialogStore } from 'reusable/gap-dialog/GapDialogStore'

const maxCsvBytes = 3 * 1024 * 1024
const noFiles: File[] = []

export default observer(function CreateClientCSVImport(props: { onClientsImported?: () => void }) {
   const gapDialogStore = useGapDialogStore()
   const createClientCSVImportStore = useStore(sp => new CreateClientCSVImportStore(sp), { gapDialogStore, onClientsImported: props.onClientsImported })

   return <Stack sx={{ gap: 2 }}>
      <FileUploadWithProgress
         accept={{ "text/csv": ['.csv'] }}
         files={noFiles}
         maxFiles={1}
         maxSize={maxCsvBytes}
         onFilesValidated={createClientCSVImportStore.onFilesValidated}
         onLastFileRemoved={createClientCSVImportStore.onLastFileRemoved}
         subtext="CSV (max. 3MB)"
      />
      {createClientCSVImportStore.parseErrors.length > 0 && <Typography variant="body2" color="error">
         We had trouble reading {createClientCSVImportStore.parseErrors.length} rows. Check the file and try again.
      </Typography>}
   </Stack>
})
